import { SpinResponse } from '@cgs/data-access';
import {
  Action,
  CGSMouseEvent,
  Container,
  EmptyAction,
  FunctionAction,
  MouseDownEvent,
  Platform,
  SceneObject,
  SequenceAction,
  T_Platform,
  Vector2,
} from '@cgs/wge';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { ISlotGame } from '../../reels_engine/i_slot_game';
import { GameStateMachine } from '../../reels_engine/state_machine/game-state-machine';
import { T_ISlotGame } from '../../type_definitions';
import { FAST_SPINS_COMPONENT, FastSpinsComponent } from './fast-spins.component';

export class FastSpinDoClickActionProvider {
  private readonly _fastSpinsProvider: FastSpinsComponent;
  private readonly _gameNode: SceneObject;
  private readonly _container: Container;
  private readonly _gameStateMachine: GameStateMachine<SpinResponse>;

  constructor(container: Container) {
    this._fastSpinsProvider = container.resolve<FastSpinsComponent>(FAST_SPINS_COMPONENT);
    this._gameNode = container.resolve<ISlotGame>(T_ISlotGame).gameNode;
    this._gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    this._container = container;
    this._gameStateMachine.animation.addParallelLazyAnimation(() => this.wrapWithSkipableAction());
    this._gameStateMachine.shortWinLines.addParallelLazyAnimation(() =>
      this.wrapWithSkipableAction()
    );
    this._gameStateMachine.stop.addParallelLazyAnimation(() => this.wrapWithSkipableAction());
  }

  private wrapWithSkipableAction(): Action {
    const platform = this._container.resolve<Platform>(T_Platform);
    const mouse = platform.inputSystem.mouse;

    if (
      this._fastSpinsProvider.isFastSpinsActive &&
      (this._gameStateMachine.curResponse.isFreeSpins || this._gameStateMachine.isAutoSpins) &&
      ((this._gameStateMachine.curResponse.winLines &&
        this._gameStateMachine.curResponse.winLines.some((x) => !!x)) ||
        this._gameStateMachine.curResponse.specialSymbolGroups)
    ) {
      return new SequenceAction([
        new EmptyAction().withDuration(0.005),
        new FunctionAction(() => {
          const spin = this._gameNode.findById('coverSpinNode')!;
          spin?.sendEvent(
            new MouseDownEvent(
              mouse,
              new CGSMouseEvent(new Vector2(spin.worldTransform.tx, spin.worldTransform.ty), 0)
            )
          );
        }),
        new EmptyAction().withDuration(0.02),
        new FunctionAction(() => {
          this._gameNode.sendEvent(
            new MouseDownEvent(mouse, new CGSMouseEvent(new Vector2(0.0, 0.0), 0))
          );
        }),
      ]);
    }

    return new EmptyAction();
  }
}
